import type MarkdownIt from 'markdown-it';
import type StateCore from 'markdown-it/lib/rules_core/state_core.mjs';

const tableBreakTags = (state: StateCore) => {
	const tokens = state.tokens;

	// Find all table tokens
	for (let i = 0; i < tokens.length; i++) {
		const token = tokens[i];

		// Check if we're inside a table
		if (token.type === 'table_open') {
			// Process all tokens until the matching table_close
			let j = i + 1;
			while (j < tokens.length && tokens[j].type !== 'table_close') {
				// If we're in a table cell content
				if (
					tokens &&
					tokens[j]?.type === 'inline' &&
					tokens[j]?.children &&
					tokens[j]?.children?.length
				) {
					// Process the content of the cell
					const children = tokens[j]?.children;

					if (!children) {
						continue;
					}

					for (let k = 0; k < children.length; k++) {
						const child = children[k];

						if (!child) {
							continue;
						}

						// Replace <br>, <br/>, and <br /> tags with newlines
						// Match different variations of <br> tags
						const brRegex = /<br\s*\/?>/gi;
						if (brRegex.test(child.content)) {
							child.content = child.content.replace(brRegex, '\n');

							// If the content is now just a newline, change the token type
							if (child.content === '\n') {
								child.type = 'hardbreak';
							}
						}
					}
				}
				j++;
			}

			// Skip to the end of the table
			i = j;
		}
	}
	return;
};

export default (md: MarkdownIt) => md.core.ruler.push('table-break-tags', tableBreakTags);
